import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import User from '../../../components/user/user/listar/senha';


function EditUserSenhaScreen () {
    return (
        <Fragment>
            <Head titulo="Edição de Senha do Usuário | Departamento de TI" />
            <Header />
            <User />
            <Footer />
        </Fragment>
    );
}

export default EditUserSenhaScreen;